import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BookingsFilters, BookingsResponse, EarningsStatisticsResponse, UserStatisticsResponse } from 'shared';

export interface UserStatsDetail {
  all: number;
  active: number;
  inactive: number;
  unverified: number;
}

export interface DashboardStats {
  total: UserStatsDetail;
  day_1: UserStatsDetail;
  day_7: UserStatsDetail;
  day_30: UserStatsDetail;
  day_90: UserStatsDetail;
}

@Injectable({ providedIn: 'root' })
export class UserService {

  constructor(private http: HttpClient) {}

  setConsent(entityId: string) {
    const body = { entityId };
    return this.http.post<{ message: string; consents: any }>(
      '/user/consents',
      body
    );
  }

  getDashboardStats(): Observable<DashboardStats> {
    return this.http.get<DashboardStats>('/user/dashboard_stats');
  }

  getUserStatistics(): Observable<UserStatisticsResponse> {
    return this.http.get<UserStatisticsResponse>('/user/statistics');
  }

  getEarningsStatistics(): Observable<EarningsStatisticsResponse> {
    return this.http.get<EarningsStatisticsResponse>('/user/earnings_statistics');
  }

  getBookings(filters: BookingsFilters = {}): Observable<BookingsResponse> {
    let params = new HttpParams();

    if (filters.page) {
      params = params.set('page', filters.page.toString());
    }
    if (filters.per_page) {
      params = params.set('per_page', filters.per_page.toString());
    }
    if (filters.booking_type) {
      params = params.set('booking_type', filters.booking_type);
    }

    return this.http.get<BookingsResponse>('/user/bookings', { params });
  }

  exportBookings(): Observable<Blob> {
    return this.http.get('/user/bookings/export', {
      responseType: 'blob'
    });
  }
}